module.exports = __webpack_public_path__ + "img/beian.2ce2f33d.png";